(function () {
  'use strict';

  function toTitle(name) {
    return String(name || '')
      .split('-')
      .filter(Boolean)
      .map(function (part) {
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  }

  function parseWantedSets(mount) {
    var raw = (mount.getAttribute('data-font-icon-sets') || '').trim();
    if (!raw) return [];

    return raw
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function addToken(map, key, token) {
    if (!map[key]) map[key] = new Set();
    map[key].add(token);
  }

  function componentToHex(value) {
    var normalized = Math.max(0, Math.min(255, Number(value) || 0));
    var hex = normalized.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  function rgbStringToHex(value) {
    var match = String(value || '').match(/rgba?\(([^)]+)\)/i);
    if (!match || !match[1]) return '';

    var parts = match[1].split(',').map(function (part) {
      return parseFloat(String(part || '').trim());
    });

    if (parts.length < 3) return '';

    return (
      '#' +
      componentToHex(parts[0]) +
      componentToHex(parts[1]) +
      componentToHex(parts[2])
    ).toUpperCase();
  }

  var resolvedColorHexCache = {};

  function resolveColorHex(setName, iconName) {
    var key = setName + '--' + iconName;

    if (Object.prototype.hasOwnProperty.call(resolvedColorHexCache, key)) {
      return resolvedColorHexCache[key];
    }

    var probe = document.createElement('span');
    probe.className = 'font-icon--color--' + setName + '--' + iconName;
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.pointerEvents = 'none';

    document.body.appendChild(probe);

    var resolved = '';
    try {
      resolved = rgbStringToHex(window.getComputedStyle(probe).color);
    } catch (err) {
      resolved = '';
    }

    document.body.removeChild(probe);
    resolvedColorHexCache[key] = resolved;

    return resolved;
  }

  function parseAnyIconSelector(selector) {
    var iconRegex = /^\.font-icon--([a-z0-9]+(?:-[a-z0-9]+)*)--([a-z0-9-]+)(?::before|::before)$/i;
    var match = String(selector || '').match(iconRegex);
    if (!match) return null;
    return {
      set: String(match[1] || ''),
      icon: String(match[2] || '')
    };
  }

  function parseAnyColorSelector(selector) {
    var colorRegex = /^\.font-icon--color--([a-z0-9]+(?:-[a-z0-9]+)*)--([a-z0-9-]+)(?:--[a-z0-9-]+)?$/i;
    var match = String(selector || '').match(colorRegex);
    if (!match) return null;
    return {
      set: String(match[1] || ''),
      icon: String(match[2] || '')
    };
  }

  function scanStyleRules() {
    var sets = {};
    var colors = {};
    var discoveredSets = new Set();

    var styleSheets = Array.prototype.slice.call(document.styleSheets || []);

    styleSheets.forEach(function (sheet) {
      var rules;

      try {
        rules = sheet.cssRules || sheet.rules;
      } catch (err) {
        return;
      }

      if (!rules) return;

      Array.prototype.forEach.call(rules, function (rule) {
        var selectorText = String(rule && rule.selectorText ? rule.selectorText : '');
        if (!selectorText) return;

        var selectors = selectorText.split(',').map(function (x) { return x.trim(); });

        selectors.forEach(function (selector) {
          var anyIcon = parseAnyIconSelector(selector);
          if (anyIcon) {
            addToken(sets, anyIcon.set, anyIcon.icon);
            discoveredSets.add(anyIcon.set);
          }

          var anyColor = parseAnyColorSelector(selector);
          if (anyColor) {
            addToken(colors, anyColor.set, anyColor.icon);
            discoveredSets.add(anyColor.set);
          }
        });
      });
    });

    return {
      sets: sets,
      colors: colors,
      discoveredSets: Array.from(discoveredSets).sort()
    };
  }

  function discoverSetsFromStyleRules(scanResult) {
    return (scanResult && Array.isArray(scanResult.discoveredSets))
      ? scanResult.discoveredSets.slice()
      : [];
  }

  function collectFromStyleRules(wantedSets, scanResult) {
    var sets = scanResult && scanResult.sets ? scanResult.sets : {};
    var colors = scanResult && scanResult.colors ? scanResult.colors : {};
    var wantedSetLookup = {};

    wantedSets.forEach(function (setName) {
      wantedSetLookup[setName] = true;
    });

    var result = wantedSets
      .filter(function (setName) {
        return wantedSetLookup[setName] && sets[setName] && sets[setName].size > 0;
      })
      .map(function (setName) {
        var discovered = Array.from(sets[setName]);
        var icons = discovered.sort();

        return {
          set: setName,
          icons: icons,
          colorIcons: colors[setName] ? new Set(Array.from(colors[setName])) : new Set()
        };
      });

    return result;
  }

  function renderSections(mount, grouped) {
    mount.innerHTML = '';

    grouped.forEach(function (group) {
      var h3 = document.createElement('h3');
      h3.textContent = toTitle(group.set);
      mount.appendChild(h3);

      var wrapper = document.createElement('div');
      wrapper.className = 'font-icon--set';

      group.icons.forEach(function (iconName) {
        var tile = document.createElement('div');
        tile.className = 'font-icon--container';
        var colorHex = '';

        if (group.colorIcons.has(iconName)) {
          tile.setAttribute('data-font-icon-palette', '1');
          tile.setAttribute('data-font-icon-set', group.set);
          tile.setAttribute('data-font-icon-name', iconName);
          colorHex = resolveColorHex(group.set, iconName);
        }

        var p = document.createElement('p');

        var icon = document.createElement('span');
        icon.className = 'font-icon--' + group.set + '--' + iconName;

        var label = document.createElement('span');
        label.textContent = 'font-icon--' + group.set + '--' + iconName;

        p.appendChild(icon);
        p.appendChild(label);

        if (colorHex) {
          p.appendChild(document.createElement('br'));
          var colorText = document.createElement('small');
          colorText.textContent = colorHex;
          p.appendChild(colorText);
        }

        tile.appendChild(p);
        wrapper.appendChild(tile);
      });

      mount.appendChild(wrapper);
    });
  }

  function clearPaletteClasses(el) {
    var toRemove = [];
    for (var i = 0; i < el.classList.length; i += 1) {
      var cls = String(el.classList[i] || '');
      if (cls.indexOf('font-icon--color--') === 0) {
        toRemove.push(cls);
      }
    }
    toRemove.forEach(function (cls) {
      el.classList.remove(cls);
    });
  }

  function applyPaletteMode(mode) {
    var targets = document.querySelectorAll('[data-font-icon-palette="1"]');

    Array.prototype.forEach.call(targets, function (el) {
      var setName = el.getAttribute('data-font-icon-set') || '';
      var iconName = el.getAttribute('data-font-icon-name') || '';
      if (!setName || !iconName) return;

      clearPaletteClasses(el);

      if (mode === 'none') return;

      var base = 'font-icon--color--' + setName + '--' + iconName;

      if (mode === 'primary-bg') {
        el.classList.add(base + '--background');
        el.classList.add(base);
      } else if (mode === 'alt-bg') {
        el.classList.add(base + '--background--alt');
        el.classList.add(base + '--alt');
      } else if (mode === 'primary-text') {
        el.classList.add(base);
      } else if (mode === 'alt-text') {
        el.classList.add(base + '--alt');
      }
    });
  }

  function bindPaletteControl() {
    var select = document.getElementById('FontIconPaletteMode');
    if (!select) return;

    applyPaletteMode(select.value);

    select.addEventListener('change', function () {
      applyPaletteMode(select.value);
    });
  }

  function renderInlineCodeList(mount, items, maxItems, formatter) {
    var list = Array.isArray(items) ? items : [];
    var limit = Math.max(0, Number(maxItems) || 0);
    var visible = list.slice(0, limit);

    mount.textContent = '';

    if (!visible.length) {
      mount.textContent = 'none';
      return;
    }

    visible.forEach(function (item, idx) {
      var code = document.createElement('code');
      code.textContent = formatter(item);
      mount.appendChild(code);

      if (idx < visible.length - 1) {
        mount.appendChild(document.createTextNode(', '));
      }
    });

    if (list.length > visible.length) {
      mount.appendChild(document.createTextNode(', etc'));
    }
  }

  function renderRequestedSetCopy(wantedSets) {
    var mount = document.getElementById('FontIconRequestedSets');
    if (!mount) return;

    renderInlineCodeList(mount, wantedSets, 4, function (setName) {
      return setName;
    });
  }

  function renderNamespaceExamples(wantedSets) {
    var mount = document.getElementById('FontIconNamespaceExamples');
    if (!mount) return;

    renderInlineCodeList(mount, wantedSets, 2, function (setName) {
      return 'font-icon--' + setName + '--*';
    });
  }

  function boot() {
    var mount = document.getElementById('FontIconExamplesAuto');
    if (!mount) return;

    var scanResult = scanStyleRules();
    var wantedSets = parseWantedSets(mount);
    if (!wantedSets.length) {
      wantedSets = discoverSetsFromStyleRules(scanResult);
    }
    if (!wantedSets.length) return;

    renderRequestedSetCopy(wantedSets);
    renderNamespaceExamples(wantedSets);

    var grouped = collectFromStyleRules(wantedSets, scanResult);
    renderSections(mount, grouped);
    bindPaletteControl();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
